/* Gates Belt Cross-Reference — AIMS Industrial
   Search behaviour is a direct port of GatesXRef.html. Data is unchanged.
   Everything is inside one IIFE: nothing is added to window. */
(function () {
  'use strict';

  var cache = null; // shared across instances: { total, brands, sku, rows, n0, n1, n2 }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function norm(s) {
    return String(s == null ? '' : s).toUpperCase().replace(/[\s\-]/g, '');
  }

  /* Levenshtein, two rolling rows with an early bail once every cell exceeds max.
     Returns max+1 instead of the true distance when the true distance is above max,
     which is all the caller needs. Scratch arrays are passed in and reused. */
  function lev(a, b, max, prev, cur) {
    if (a === b) return 0;
    var la = a.length, lb = b.length;
    if (!la) return lb;
    if (!lb) return la;
    if (la - lb > max || lb - la > max) return max + 1;

    var i, j;
    for (j = 0; j <= la; j++) prev[j] = j;

    for (i = 1; i <= lb; i++) {
      cur[0] = i;
      var rowMin = i;
      var bc = b.charCodeAt(i - 1);
      for (j = 1; j <= la; j++) {
        var cost = a.charCodeAt(j - 1) === bc ? 0 : 1;
        var v = prev[j - 1] + cost;
        var up = prev[j] + 1;
        if (up < v) v = up;
        var left = cur[j - 1] + 1;
        if (left < v) v = left;
        cur[j] = v;
        if (v < rowMin) rowMin = v;
      }
      if (rowMin > max) return max + 1;
      var swap = prev; prev = cur; cur = swap;
    }
    return prev[la];
  }

  function loadData(url) {
    if (cache) return Promise.resolve(cache);
    return fetch(url, { credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var rows = data.rows || [];
        var n0 = new Array(rows.length);
        var n1 = new Array(rows.length);
        var n2 = new Array(rows.length);
        // Normalise once on load rather than on every keystroke.
        for (var i = 0; i < rows.length; i++) {
          n0[i] = norm(rows[i][0]);
          n1[i] = norm(rows[i][1]);
          n2[i] = rows[i][2] ? norm(rows[i][2]) : '';
        }
        cache = {
          total: data.total || rows.length,
          brands: data.brands || [],
          sku: data.sku || {},
          rows: rows,
          n0: n0, n1: n1, n2: n2
        };
        return cache;
      });
  }

  function init(root) {
    var dataUrl = root.getAttribute('data-gbx-data');
    var searchBase = root.getAttribute('data-gbx-search-url') || '/search';
    var maxRender = parseInt(root.getAttribute('data-gbx-max-results'), 10);
    if (!maxRender || maxRender < 1) maxRender = 200;

    var input = root.querySelector('[data-gbx-input]');
    var clearBtn = root.querySelector('[data-gbx-clear]');
    var statusEl = root.querySelector('[data-gbx-status]');
    var tbody = root.querySelector('[data-gbx-tbody]');
    var brandList = root.querySelector('[data-gbx-brand-list]');
    var brandCount = root.querySelector('[data-gbx-brand-count]');
    var brandWrap = root.querySelector('[data-gbx-brands]');
    var resultsEl = root.querySelector('[data-gbx-results]');
    var welcomeHtml = tbody ? tbody.innerHTML : '';

    if (!input || !tbody || !statusEl) return;

    var db = null;
    var loading = false;
    var timer = null;
    var pending = null; // a query typed before the data finished loading

    function setStatus(html) { statusEl.innerHTML = html; }

    function skuFor(row) {
      return db.sku[String(row[1]).toUpperCase()] || db.sku[String(row[2]).toUpperCase()] || '';
    }

    function skuCell(row) {
      var sku = skuFor(row);
      if (!sku) return '<span class="gbx__sku-none">—</span>';
      return '<a class="gbx__sku-link" href="' + esc(searchBase) + '?q=' +
        encodeURIComponent(sku) + '" rel="nofollow">' + esc(sku) + '</a>';
    }

    function rowHtml(row, n, extraClass) {
      return '<tr' + (extraClass ? ' class="' + extraClass + '"' : '') + '>' +
        '<td class="gbx__index">' + n + '</td>' +
        '<td class="gbx__num gbx__oem" data-label="OEM / Genuine No.">' + esc(row[0]) + '</td>' +
        '<td class="gbx__num gbx__std" data-label="Gates Standard">' + esc(row[1]) + '</td>' +
        '<td class="gbx__num gbx__prem" data-label="Gates Premium">' + (row[2] ? esc(row[2]) : '—') + '</td>' +
        '<td data-label="Belt Application">' + esc(row[3]) + '</td>' +
        '<td data-label="Brand / Make">' + esc(row[4]) + '</td>' +
        '<td class="gbx__sku" data-label="AIMS SKU">' + skuCell(row) + '</td>' +
        '</tr>';
    }

    function renderRows(list, extraClass) {
      var out = '';
      for (var i = 0; i < list.length; i++) out += rowHtml(list[i], i + 1, extraClass);
      return out;
    }

    function groupRow(text, variant) {
      return '<tr class="gbx__meta-row"><td colspan="7" class="gbx__group gbx__group--' +
        variant + '">' + text + '</td></tr>';
    }

    /* Render a capped result set. matchCount stays the true total so the status line
       and the notice both tell the truth about how many matches exist. */
    function renderCapped(list, headerText, extraClass) {
      var shown = list.length > maxRender ? list.slice(0, maxRender) : list;
      var html = groupRow(headerText, 'exact') + renderRows(shown, extraClass);
      if (list.length > shown.length) {
        html += groupRow('Showing the first ' + shown.length + ' of ' + list.length +
          ' matches — add more characters to narrow it down.', 'note');
      }
      return html;
    }

    function clearActiveBrand() {
      var actives = root.querySelectorAll('.gbx__brand.is-active');
      for (var i = 0; i < actives.length; i++) actives[i].classList.remove('is-active');
    }

    function reset(msg) {
      clearActiveBrand();
      tbody.innerHTML = welcomeHtml;
      setStatus(msg || ('Ready — ' + (db ? db.total.toLocaleString() : '') + ' cross-references loaded'));
    }

    function track(term, count) {
      if (typeof window.gtag !== 'function') return;
      window.gtag('event', 'gates_xref_search', {
        search_term: term,
        results_count: count,
        has_results: count > 0
      });
    }

    function search(raw) {
      var t = norm(raw);
      if (!t) { reset(); return; }
      clearActiveBrand();

      var rows = db.rows, n0 = db.n0, n1 = db.n1, n2 = db.n2, len = rows.length;
      var i;

      var exactHits = [];
      for (i = 0; i < len; i++) {
        if (n0[i] === t || n1[i] === t || (n2[i] && n2[i] === t)) exactHits.push(rows[i]);
      }

      var containsHits = [];
      if (exactHits.length === 0) {
        for (i = 0; i < len; i++) {
          if (n0[i].indexOf(t) !== -1 || n1[i].indexOf(t) !== -1 ||
              (n2[i] && n2[i].indexOf(t) !== -1)) containsHits.push(rows[i]);
        }
      }

      var fuzzyHits = [];
      if (t.length >= 4) {
        var found = Object.create(null);
        var seen = exactHits.length ? exactHits : containsHits;
        for (i = 0; i < seen.length; i++) found[seen[i][0] + '|' + seen[i][1]] = true;

        var maxDist = Math.min(3, Math.floor(t.length / 3) + 1);
        var prev = new Array(t.length + 1);
        var cur = new Array(t.length + 1);
        var scored = [];

        for (i = 0; i < len; i++) {
          if (found[rows[i][0] + '|' + rows[i][1]]) continue;
          // Same as the original bestDist: the smallest distance across all three columns.
          var d = lev(t, n0[i], maxDist, prev, cur);
          var d1 = lev(t, n1[i], maxDist, prev, cur);
          if (d1 < d) d = d1;
          if (n2[i]) {
            var d2 = lev(t, n2[i], maxDist, prev, cur);
            if (d2 < d) d = d2;
          }
          if (d <= maxDist) scored.push({ r: rows[i], d: d });
        }
        scored.sort(function (a, b) { return a.d - b.d; });
        fuzzyHits = scored.slice(0, 10).map(function (x) { return x.r; });
      }

      var html = '';
      var matchCount = exactHits.length || containsHits.length;
      var label = esc(String(raw).trim());

      if (exactHits.length > 0) {
        html += renderCapped(exactHits,
          '&#10003; ' + exactHits.length + ' match' + (exactHits.length > 1 ? 'es' : '') +
          ' found for &ldquo;' + label + '&rdquo;');
      } else if (containsHits.length > 0) {
        html += renderCapped(containsHits,
          '&#10003; ' + containsHits.length + ' partial match' + (containsHits.length > 1 ? 'es' : '') +
          ' for &ldquo;' + label + '&rdquo;');
      }

      if (fuzzyHits.length > 0) {
        html += groupRow('&#128270; Close numbers — did you mean one of these?', 'fuzzy');
        html += renderRows(fuzzyHits, 'gbx__row--fuzzy');
      }

      track(String(raw).trim(), matchCount);

      if (!html) {
        tbody.innerHTML = '<tr class="gbx__meta-row"><td colspan="7" class="gbx__empty">' +
          'No matches for &ldquo;' + label + '&rdquo;. Check the number and try again, or ' +
          '<a href="/pages/contact">ask us to look it up</a>.</td></tr>';
        setStatus('No matches for &ldquo;' + label + '&rdquo;');
        return;
      }

      tbody.innerHTML = html;
      if (matchCount > 0) {
        setStatus('<strong>' + matchCount + '</strong> match' + (matchCount > 1 ? 'es' : '') +
          ' for <strong>' + label + '</strong>' +
          (fuzzyHits.length > 0 ? ' &nbsp;&middot;&nbsp; ' + fuzzyHits.length + ' close numbers below' : ''));
      } else {
        setStatus('No exact match — <strong>' + fuzzyHits.length + '</strong> close number' +
          (fuzzyHits.length > 1 ? 's' : '') + ' shown for <strong>' + label + '</strong>');
      }
    }

    function filterBrand(brand, btn) {
      input.value = '';
      clearActiveBrand();
      btn.classList.add('is-active');
      var hits = db.rows.filter(function (r) { return r[4] === brand; });
      tbody.innerHTML = renderCapped(hits,
        hits.length + ' belt' + (hits.length > 1 ? 's' : '') + ' for ' + esc(brand));
      setStatus('<strong>' + hits.length + '</strong> belt' + (hits.length > 1 ? 's' : '') +
        ' for <strong>' + esc(brand) + '</strong>');
      if (resultsEl && resultsEl.scrollIntoView) {
        resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function buildBrands() {
      if (brandCount && db.brands.length) {
        brandCount.textContent = '(' + db.brands.length.toLocaleString() + ' brands)';
      }
      if (!brandList || brandList.getAttribute('data-built') === '1') return;
      var frag = document.createDocumentFragment();
      db.brands.forEach(function (b) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'gbx__brand';
        btn.textContent = b;
        btn.addEventListener('click', function () { filterBrand(b, btn); });
        frag.appendChild(btn);
      });
      brandList.appendChild(frag);
      brandList.setAttribute('data-built', '1');
    }

    /* Data is ~500 KB, so it is fetched on first interaction rather than on page load. */
    function ensureData() {
      if (db) return Promise.resolve(db);
      if (loading) return loading;
      setStatus('Loading cross-reference data…');
      loading = loadData(dataUrl)
        .then(function (data) {
          db = data;
          buildBrands();
          if (brandWrap) brandWrap.hidden = false;
          if (pending != null) { var q = pending; pending = null; search(q); }
          else reset();
          return db;
        })
        .catch(function (err) {
          loading = false;
          setStatus('Couldn’t load the cross-reference data. Please refresh the page, or ' +
            '<a href="/pages/contact">contact us</a> and we’ll look the number up for you.');
          if (window.console) window.console.error('[gates-xref]', err);
        });
      return loading;
    }

    function run(value) {
      if (db) { search(value); return; }
      pending = value;
      ensureData();
    }

    input.addEventListener('focus', ensureData, { once: true });
    input.addEventListener('input', function () {
      var v = this.value;
      clearTimeout(timer);
      timer = setTimeout(function () { run(v); }, 300);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); clearTimeout(timer); run(this.value); }
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        clearTimeout(timer);
        if (db) reset();
        input.focus();
      });
    }

    if (brandWrap) {
      brandWrap.addEventListener('toggle', function () {
        if (brandWrap.open) ensureData();
      });
    }

    // Deep link: /pages/... ?part=A38 runs the search on load and makes results shareable.
    var q = new URLSearchParams(window.location.search).get('part');
    if (q) { input.value = q; run(q); }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-gbx]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].getAttribute('data-gbx-ready') === '1') continue;
      roots[i].setAttribute('data-gbx-ready', '1');
      init(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', boot);
})();